import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'app/core/services/auth.service';
import { Module, NewPermission } from '../enums';
import { unauthorizedHandler } from './unauthorized-handler';

@Injectable({ providedIn: 'root' })
export class AuthorizationGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (state.url.startsWith('/unauthorized')) {
      return true;
    } else {
      const module = route.data?.module as Module;

      if (module === Module.AGGREGATED_TASKS) {
        const hasAny = this.authService.hasAnyPermissionInModule(module);

        if (!hasAny) {
          unauthorizedHandler(this.authService, this.router);
        }

        return hasAny;
      }

      const permission = route.data?.permission as NewPermission;

      if (permission) {
        const hasPermission = this.authService.hasPermission(permission);

        if (!hasPermission) {
          unauthorizedHandler(this.authService, this.router);
        }

        return hasPermission;
      }

      if (module) {
        let hasAny = this.authService.hasAnyPermissionInModule(module);
        if (!hasAny && module === Module.SETTINGS) {
          this.router.navigate(['settings/jobs-status']);
          return true;
        }

        if (!hasAny) {
          unauthorizedHandler(this.authService, this.router);
        }

        return hasAny;
      }
    }

    return true;
  }
}
